import(/* webpackMode: "eager" */ "/workspace/app/@headerIcons/default.tsx");
